export default __webpack_public_path__ + "static/media/date-and-time.4069399a.svg";